import React, { Component } from 'react';
import './scss/orderItem.scss';

interface InjectedProps {
  orderItem: any;
  labelWithTariffPackage: string;
  labelSimOnlyCard?: string;
}

const withOrderItems = <T extends InjectedProps>(WrappedComponent: React.ComponentType<T>) => {
  return class WithOrderItems extends Component<InjectedProps, {}> {

    render() {
      const {
        orderItem,
        labelWithTariffPackage,
        labelSimOnlyCard
      } = this.props;

      return (
        <div className={'order-item'}>
          <WrappedComponent
            {...this.props as T}
            orderItem={orderItem}
            labelWithTariffPackage={labelWithTariffPackage}
            labelSimOnlyCard={labelSimOnlyCard}
          />
        </div>
      );
    }

  };
};

export default withOrderItems;
